import { render, staticRenderFns } from "./mayiba_shangpin.vue?vue&type=template&id=c7a01c68&"
import script from "./mayiba_shangpin.vue?vue&type=script&lang=js&"
export * from "./mayiba_shangpin.vue?vue&type=script&lang=js&"
import style0 from "./mayiba_shangpin.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports